// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tAgC","colMin":"styles_colMin__2Nmu7"};